// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"UserInformation_PageHolder__1Ot0c","InputHolder":"UserInformation_InputHolder__OSc59","firstSpan":"UserInformation_firstSpan__-RNgZ"};